// extracted by mini-css-extract-plugin
export default {"patent-loading-page":"styles_patent-loading-page__a0A+I"};